import type { Dispatch, SetStateAction } from 'react'
import type { FormularioRepresentada } from '../../representadas/formularioRepresentada'

export const ESTILO_CAMPO = 'w-full border border-slate-300 rounded-lg px-3 py-2 disabled:bg-slate-50 disabled:text-slate-700'
export const ESTILO_ROTULO = 'block text-sm text-slate-600 mb-1'
export const ESTILO_CARTAO = 'bg-white rounded-xl shadow-sm p-4 space-y-3'

// Visual novo (spec 27/09): Identificacao e Localizacao continuam com o
// ESTILO_CARTAO antigo; o visual novo comeca pela Politica Comercial.
export const ESTILO_CARTAO_NOVO = 'bg-white rounded-2xl border border-slate-200/70 shadow-[0_6px_16px_-4px_rgba(15,23,42,0.14),0_2px_4px_rgba(15,23,42,0.06)] p-3'
export const ESTILO_ICONE_CARTAO = 'shrink-0 w-9 h-9 rounded-xl bg-teal-50 text-teal-700 flex items-center justify-center'
export const ESTILO_SELO_VERDE = 'text-[11px] font-medium rounded-full px-2 py-0.5 bg-teal-50 text-teal-800'
export const ESTILO_SELO_CINZA = 'text-[11px] font-medium rounded-full px-2 py-0.5 bg-slate-100 text-slate-500'
export const ESTILO_SELO_DESCONTO = 'text-[11px] font-semibold rounded-full px-2 py-0.5 bg-amber-100 text-amber-800'

export interface PropsAba {
  form: FormularioRepresentada
  setForm: Dispatch<SetStateAction<FormularioRepresentada>>
  editavel: boolean
}
